import Vue from "vue"
import Vuex from "vuex"
import {
    getCookie,
    delCookie
} from 'src/assets/js/dom'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userInfo: (window.location.hostname === 'tiku.buzhi.com' || window.location.hostname === 'tiku.test.buzhi.com') ? getCookie("bzgk_buzhi_user_auth") || '' : getCookie("xo_buzhi_user_auth") || '' //用户信息  cookie   
    },
    mutations: {
        // 清空用户信息／退出
        CLEAR_USERINFO(state) {
            state.userInfo = ''
            (window.location.hostname === 'tiku.buzhi.com' || window.location.hostname === 'tiku.test.buzhi.com') ? delCookie("bzgk_buzhi_user_auth") : delCookie("xo_buzhi_user_auth")
        }
    },
    actions: {
        clear_userinfo({commit}){
            commit("CLEAR_USERINFO")
        }        
    },
    getters: {
        uid: state => {
            try{
                if(state.userInfo){
                    let user = JSON.parse(state.userInfo)            
                    return user.id
                }
            }catch(e){
                console.log('id格式有误')
            }
        },
        phone: state => {
            try{
                if(state.userInfo){
                    let user = JSON.parse(state.userInfo)            
                    return decodeURIComponent(user.mobile)
                }
            }catch(e){
                console.log('mobile格式有误')
            }
        },
        nikename: state => {
            try {
                if(state.userInfo){
                    let user = JSON.parse(state.userInfo)            
                    return decodeURIComponent(user.nikename)
                }
            } catch (e) {
                console.log('nikename格式有误')
            }
        },
        avatar: state =>{
            try {
                if(state.userInfo){
                    let user = JSON.parse(state.userInfo)
                    let img = user.avatar
                    if(img){
                        return decodeURIComponent(img)
                    }else{
                        return '/static/images/default-avatar.png'
                    }
                }
            } catch (e) {
                console.log('avatar格式有误')
            }
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js